import * as React from 'react';
import { useAssetId } from 'owa-timestream-asset-sdk';
import {
    createLockedCalendarEventsStore,
    getLockedCalendarEventsReader,
} from 'owa-calendar-events-store';
import type { ClientItemId } from 'owa-client-ids';
import getStoreCalendarEvent from './getCalendarEvent';
import getStoreCalendarEventsForDateRange from './getCalendarEventsForDateRange';
import type { DateRange } from 'owa-datetime-utils';

const stores = {};

export default function useGetCalendarEvents() {
    const assetId = useAssetId();

    React.useEffect(() => {
        // when the asset unmounts, either due to deletion or switching Spaces, clean up the store value
        return () => {
            delete stores[assetId];
        };
    }, []);

    if (!assetId) {
        return {
            getCalendarEvent: () => null,
            getCalendarEventsForDateRange: () => null,
        };
    }

    if (!stores[assetId]) {
        // store not yet created for this asset
        stores[assetId] = createLockedCalendarEventsStore(assetId);
    }

    const store = stores[assetId];
    const storeReader = getLockedCalendarEventsReader(store.getLockId());

    const getCalendarEvent = (itemId: string | ClientItemId, onNotFoundError: () => void) => {
        return getStoreCalendarEvent(itemId, onNotFoundError, store, storeReader);
    };

    const getCalendarEventsForDateRange = (folderId: string, dateRange: DateRange) => {
        return getStoreCalendarEventsForDateRange(folderId, dateRange, store);
    };

    return {
        getCalendarEvent,
        getCalendarEventsForDateRange,
    };
}
